(function ($) {
  "use strict";

  var POI_CATEGORIES = {
    bolt: { label: "Bolt", color: "#43A047" },
    egeszseg: { label: "Egészségügy", color: "#E53935" },
    oktatas: { label: "Oktatás", color: "#3B82F6" },
    szorakozas: { label: "Szórakozás", color: "#F59E0B" },
    bank: { label: "Bank", color: "#757575" },
  };

  function escapeHtml(value) {
    return $("<div>").text(value == null ? "" : String(value)).html();
  }

  function getPoiPopupContent(poi) {
    return "<strong>" + escapeHtml(poi.name) + "</strong>";
  }

  function loadPoiLayer(lat, lng, radius, ajaxUrl, poiLayers) {
    var url =
      ajaxUrl +
      "?action=cordia_nearby_pois" +
      "&lat=" + encodeURIComponent(lat) +
      "&lng=" + encodeURIComponent(lng) +
      "&radius=" + encodeURIComponent(radius);

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        if (!json.success || !json.data || !json.data.pois) {
          throw new Error("Invalid POI response");
        }

        json.data.pois.forEach(function (poi) {
          var cat = poi.category;
          if (!poiLayers[cat]) return;

          L.circleMarker([poi.lat, poi.lon], {
            radius: 7,
            fillColor: POI_CATEGORIES[cat].color,
            color: "#fff",
            weight: 1.5,
            opacity: 1,
            fillOpacity: 0.85,
          })
            .bindPopup(getPoiPopupContent(poi))
            .addTo(poiLayers[cat]);
        });
      })
      .catch(function (err) {
        console.error("POI lekérdezés hiba:", err);
      });
  }

  function loadBkkLayer(lat, lng, radius, ajaxUrl, bkkLayer) {
    var url =
      ajaxUrl +
      "?action=cordia_bkk_nearby_stops" +
      "&lat=" + encodeURIComponent(lat) +
      "&lng=" + encodeURIComponent(lng) +
      "&radius=" + encodeURIComponent(radius);

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        if (!json.success || !json.data || !json.data.stops) {
          throw new Error("Invalid BKK response");
        }

        json.data.stops.forEach(function (stop) {
          var routes = stop.routes || [];
          var popup = "<strong>" + escapeHtml(stop.stop_name) + "</strong>";

          if (routes.length) {
            popup += '<div class="pm-property-map__popup-routes">';
            routes.forEach(function (r) {
              var href = r.route_id
                ? "https://go.bkk.hu/route/" + encodeURIComponent(r.route_id)
                : null;
              var tag = href ? "a" : "span";

              popup +=
                "<" + tag +
                ' class="pm-property-map__badge" style="background-color:' +
                r.color +
                ";color:" +
                r.text_color +
                '"' +
                (href ? ' href="' + escapeHtml(href) + '" target="_blank" rel="noopener noreferrer"' : "") +
                ">" +
                escapeHtml(r.short_name) +
                "</" + tag + ">";
            });
            popup += "</div>";
          }

          L.circleMarker([stop.stop_lat, stop.stop_lon], {
            radius: 7,
            fillColor: "#7C3AED",
            color: "#fff",
            weight: 1.5,
            opacity: 1,
            fillOpacity: 0.85,
          })
            // Fix minWidth, hogy a badge-ek flex-wrap konténere ne csukódjon
            // egy oszlopba, és kb. 3 badge elférjen egy sorban.
            .bindPopup(popup, { minWidth: 240 })
            .addTo(bkkLayer);
        });
      })
      .catch(function (err) {
        console.error("BKK lekérdezés hiba:", err);
      });
  }

  function buildLegend(map, poiLayers, bkkLayer) {
    var legend = L.control({ position: "bottomright" });

    legend.onAdd = function () {
      var wrap = L.DomUtil.create("div");
      L.DomEvent.disableClickPropagation(wrap);

      // --- POI panel ---
      var poiPanel = L.DomUtil.create("div", "pm-property-map__legend-poi", wrap);
      Object.keys(POI_CATEGORIES).forEach(function (key) {
        var cat = POI_CATEGORIES[key];
        var row = L.DomUtil.create("label", "pm-property-map__legend-poi-row", poiPanel);

        var cb = L.DomUtil.create("input", "pm-property-map__legend-checkbox", row);
        cb.type = "checkbox";
        cb.checked = false;

        var dot = L.DomUtil.create("i", "", row);
        dot.style.background = cat.color;

        var lbl = L.DomUtil.create("span", "", row);
        lbl.textContent = cat.label;

        cb.addEventListener("change", function () {
          if (this.checked) {
            map.addLayer(poiLayers[key]);
          } else {
            map.removeLayer(poiLayers[key]);
          }
        });
      });

      // --- BKK panel ---
      var bkkPanel = L.DomUtil.create("div", "pm-property-map__legend-bkk", wrap);

      var title = L.DomUtil.create("div", "pm-property-map__legend-bkk-title", bkkPanel);
      title.textContent = "BKK megállók a közelben";

      var row = L.DomUtil.create("label", "pm-property-map__legend-bkk-row", bkkPanel);

      var toggleWrap = L.DomUtil.create("div", "pm-property-map__toggle", row);
      var toggleInput = L.DomUtil.create("input", "", toggleWrap);
      toggleInput.type = "checkbox";
      toggleInput.checked = false;
      L.DomUtil.create("div", "pm-property-map__toggle-track", toggleWrap);

      var lbl = L.DomUtil.create("span", "", row);
      lbl.textContent = "Mutasd a térképen";

      toggleInput.addEventListener("change", function () {
        if (this.checked) {
          map.addLayer(bkkLayer);
        } else {
          map.removeLayer(bkkLayer);
        }
      });

      return wrap;
    };

    return legend;
  }

  function createBaseMap(container, lat, lng, pinUrl, address) {
    var map = L.map(container).setView([lat, lng], 15);

    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://bkk.hu">BKK Zrt.</a>, <a href="https://creativecommons.org/licenses/by/4.0/deed.hu">CC BY 4.0</a>',
    }).addTo(map);

    var markerOptions = {};
    if (pinUrl) {
      markerOptions.icon = L.icon({
        iconUrl: pinUrl,
        iconSize: [33, 40],
        iconAnchor: [16.5, 40],
        popupAnchor: [0, -40],
      });
    }

    L.marker([lat, lng], markerOptions)
      .addTo(map)
      .bindPopup("<strong>" + escapeHtml(address) + "</strong>");

    return map;
  }

  function initPropertyMap($canvas) {
    var lat = parseFloat($canvas.data("lat"));
    var lng = parseFloat($canvas.data("lng"));
    var radius = parseInt($canvas.data("radius"), 10) || 600;
    var address = $canvas.data("address") || "";
    var pinUrl = $canvas.data("pin-url") || "";
    var ajaxUrl =
      $canvas.data("ajax-url") ||
      (typeof localize !== "undefined" ? localize.ajaxurl : "");

    if (isNaN(lat) || isNaN(lng) || typeof L === "undefined") return;

    createBaseMap($canvas.get(0), lat, lng, pinUrl, address);

    var $section = $canvas.closest(".pm-property-map");
    var $zoomBtn = $section.find(".pm-property-map__zoom");
    var $modal = $section.find(".js-pm-property-map-modal");
    var $modalCanvas = $modal.find(".js-pm-property-map-modal-canvas");
    var $modalClose = $modal.find(".js-pm-property-map-modal-close");

    if (!$zoomBtn.length || !$modal.length || !$modalCanvas.length) return;

    var modalMap = createBaseMap($modalCanvas.get(0), lat, lng, pinUrl, address);

    var poiLayers = {};
    Object.keys(POI_CATEGORIES).forEach(function (key) {
      poiLayers[key] = L.layerGroup();
    });
    var bkkLayer = L.layerGroup();

    if (ajaxUrl) {
      loadPoiLayer(lat, lng, radius, ajaxUrl, poiLayers);
      loadBkkLayer(lat, lng, radius, ajaxUrl, bkkLayer);
    }

    buildLegend(modalMap, poiLayers, bkkLayer).addTo(modalMap);

    function openModal() {
      $modal.addClass("is-open").attr("aria-hidden", "false");
      $("body").addClass("pm-property-map-modal-open");
      setTimeout(function () {
        modalMap.invalidateSize();
      }, 0);
    }

    function closeModal() {
      $modal.removeClass("is-open").attr("aria-hidden", "true");
      $("body").removeClass("pm-property-map-modal-open");
    }

    $zoomBtn.on("click", function (e) {
      e.preventDefault();
      openModal();
    });

    $modalClose.on("click", function (e) {
      e.preventDefault();
      closeModal();
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $modal.hasClass("is-open")) {
        closeModal();
      }
    });
  }

  $(function () {
    $(".js-pm-property-map").each(function () {
      initPropertyMap($(this));
    });
  });
})(jQuery);
